var _style, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlurQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#D9D9D9;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1000,
    height: 1000
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,104)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,0) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -83.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,0) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -83.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,0) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -83.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,0) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -83.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,0) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -83.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,0) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -83.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,0) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -83.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,52) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -125.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,52) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -125.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,52) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -125.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,52) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -125.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,52) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -125.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,104) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -166.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,104) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -166.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,104) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -166.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,104) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -166.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,104) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -166.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,104) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -166.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,156) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -208.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,156) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -208.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,156) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -208.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,156) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -208.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,156) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -208.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,156) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -208.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,208) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -250.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,260) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -292.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,260) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -292.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,260) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -292.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,260) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -292.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,260) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -292.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,260) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -292.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,312) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -333.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,312) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -333.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,312) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -333.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,312) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -333.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,312) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -333.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,312) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -333.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,312) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -333.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,364) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -375.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,364) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -375.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,364) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -375.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,364) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -375.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,364) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -375.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,364) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -375.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,364) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -375.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -250.3,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -292.1,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -333.8,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1210,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,416) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -417.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -292.1,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,468) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -459,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -292.1,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -333.8,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,520) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -500.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -125.2,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -292.1,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,572) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -542.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -250.3,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -292.1,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -333.8,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,624) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -584.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,676) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -625.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -292.1,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -333.8,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,728) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -667.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -125.2,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1210,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,780) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -709.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -250.3,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -333.8,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,832) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -751,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -250.3,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,884) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -792.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -125.2,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -333.8,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,936) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -834.5,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -125.2,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -250.3,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1210,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,988) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -876.2,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -83.4,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -125.2,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -166.9,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(156,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -208.6,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(208,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -250.3,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -292.1,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -333.8,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(364,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -375.5,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,1040) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -917.9,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1210,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,1092) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -959.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,1144) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -1001.4,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,1196) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -1043.1,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -667.6,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1210,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,1248) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -1084.8,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,1300) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -1126.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(624,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -584.1,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1196,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1043.1,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1404,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1210,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,1352) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -1168.3,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -459,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(832,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -751,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(936,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -834.5,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1092,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -959.7,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1352,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1168.3,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1456,1404) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1251.7,
    y: -1210,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(416,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -417.2,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -500.7,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(572,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -542.4,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(676,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -625.9,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(780,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -709.3,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -792.8,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(988,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -876.2,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1040,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -917.9,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1001.4,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1084.8,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1300,1456) scale(0.52,0.52)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1126.6,
    y: -1251.7,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,0) scale(3.64, 3.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6-11.9H-3.2h-8.7v8.7v40.8v8.7h8.7h40.8h8.7v-8.7V-3.2v-8.7H37.6z M37.6,37.6H-3.2V-3.2h40.8V37.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1144,0) scale(3.64, 3.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-93.5-11.9h-40.8h-8.7v8.7v40.8v8.7h8.7h40.8h8.7v-8.7V-3.2v-8.7H-93.5z M-93.5,37.6h-40.8V-3.2h40.8V37.6 z"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,1144) scale(3.64, 3.64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6-143.1H-3.2h-8.7v8.7v40.8v8.7h8.7h40.8h8.7v-8.7v-40.8v-8.7H37.6z M37.6-93.5H-3.2v-40.8h40.8V-93.5z "
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,104) scale(1.56, 1.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55.6,
    y: -55.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1248,104) scale(1.56, 1.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -361.6,
    y: -55.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104,1248) scale(1.56, 1.56)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55.6,
    y: -361.6,
    className: "st1",
    width: 58.3,
    height: 58.3
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurQr);
export default __webpack_public_path__ + "static/media/blurQr.ac0f8db563e9f85cfb6d4558ee654ef6.svg";
export { ForwardRef as ReactComponent };